

































import { stringify } from "querystring";
import Vue from "vue";

export default Vue.extend({
  props: {
    checkBoxParam: {
      type: Object,
      default: Object,
    },
    checkBoxKey: {
      type: String,
      default: String,
    },
    checkFileType: {
      type: String,
      default: String,
    },
  },
  data() {
    return {
      checkHeader: Boolean,
      checkReversDepth: Boolean,
    };
  },
  watch: {
    checkHeader() {
      if (this.checkFileType === "input") {
        if (this.checkBoxKey === "header") {
          this.checkBoxParam[this.checkBoxKey] = this.checkHeader;
          this.inputFileParameter(this.checkBoxKey, Boolean(this.checkHeader));
        }
      }
      if (this.checkFileType === "output") {
        if (this.checkBoxKey === "header") {
          this.checkBoxParam[this.checkBoxKey] = this.checkHeader;
        }
      }
      this.sendInputCSV();
    },
    checkReversDepth() {
      if (this.checkFileType === "input") {
        if (this.checkBoxKey === "revers_depth") {
          this.checkBoxParam[this.checkBoxKey] = this.checkReversDepth;
          this.inputFileParameter(
            this.checkBoxKey,
            Boolean(this.checkReversDepth)
          );
        }
      }
      if (this.checkFileType === "output") {
        if (this.checkBoxKey === "revers_depth") {
          this.checkBoxParam[this.checkBoxKey] = this.checkReversDepth;
        }
      }
    },
    checkBoxParam: {
      handler() {
        (this.checkHeader = this.checkBoxParam[this.checkBoxKey]),
          (this.checkReversDepth = this.checkBoxParam[this.checkBoxKey]);
      },
      deep: true,
    },
  },
  created() {
    if (this.checkBoxKey === "header") {
      this.checkHeader = this.checkBoxParam[this.checkBoxKey];
    }
    if (this.checkBoxKey === "revers_depth") {
      this.checkReversDepth = this.checkBoxParam[this.checkBoxKey];
    }
  },
  methods: {
    sendInputCSV() {
      this.$emit("checkBoxEvent");
    },
    inputFileParameter(changeKey: string, changeBoolean: boolean) {
      this.$emit("sendInputFileParameter", changeKey, changeBoolean);
    },
  },
});
